import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = () => {
  const { toggleTheme, isDark } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`flex items-center justify-center w-8 h-8 rounded-full bg-card border border-transparent hover:bg-muted transition-all duration-200 group focus:outline-none focus:ring-0 ${isDark ? 'hover:border-[#edff00]/60' : 'hover:border-[#4c730f]/60'}`}
      title={`Switch to ${isDark ? 'light' : 'dark'} theme`}
    >
      {isDark ? (
        <Sun className="w-4 h-4 text-yellow-500 group-hover:text-yellow-400 transition-colors" />
      ) : (
        <Moon className="w-4 h-4 text-slate-600 group-hover:text-slate-500 transition-colors" />
      )}
    </button>
  );
};

export default ThemeToggle;
